export const heroSectionData = {
  topTitle: 'OUR BLOGS',
  title: 'Stories, Strategies, and Solutions',
  desc: 'Unlock practical strategies and expert tips to optimize your IT administration.',
  background: '#0D0D0E',
}
